import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Provider } from 'react-redux'
import { persistor, store } from './store/store'
import { PersistGate } from 'redux-persist/integration/react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import App from './App'
import './index.css'


const stripePromise = loadStripe('pk_test_51QhVD9FhEUpVWAbCIMMibpNfOWCKCMw8uzwQ27n3fXiIutonytzfFLCbcJekalCpnOph16azGDK7L0Scyk6QKymQ00BnIb44Fi')
const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(

    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
                <Elements stripe={stripePromise}>
                    <App />
                    <ToastContainer position={'top-center'} theme={'light'} stacked={true} isLoading={false} closeButton={true} closeOnClick={true} autoClose={5000} hideProgressBar={true} />
                </Elements>
            </BrowserRouter>
        </PersistGate>
    </Provider>

)
